module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', [_vm._v("Campaigns")]), _vm._v(" "), _c('h3', {
    staticClass: "campaign-align-title pull-right"
  }, [_vm._v(_vm._s(_vm.campaign.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 interaction-container"
  }, [_c('message-panel', {
    attrs: {
      "id": _vm.panelSettings.uuid,
      "isPaused": !!_vm.panelPaused[_vm.panelSettings.uuid],
      "title": 'Recent Messages',
      "type": 'campaign',
      "color": '#ee2465',
      "canClose": false,
      "hasSettings": false,
      "interactions": _vm.interactions(_vm.panelSettings.uuid),
      "hasSearch": false,
      "isFixedPanel": true,
      "loadingSuccess": !!_vm.loadingInteractionsSuccess[_vm.panelSettings.uuid] || false,
      "loading": _vm.loadingInteractions[_vm.panelSettings.uuid] || false,
      "hasMoreInteractions": _vm.panelHasMoreInteractions(_vm.panelSettings.uuid) || false
    },
    on: {
      "loadMore": _vm.handleLoadMore,
      "onOpenProfile": _vm.handleOpenProfile,
      "pausePanel": function($event) {
        return _vm.pausePanel(_vm.panelSettings.uuid)
      },
      "unpausePanel": function($event) {
        return _vm.unpausePanel(_vm.panelSettings.uuid)
      }
    }
  })], 1), _vm._v(" "), (_vm.loadingCampaignReport) ? _c('div', {
    staticClass: "col-lg-8"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your campaign's details..."
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.campaign) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingCampaignReport),
      expression: "!loadingCampaignReport"
    }],
    staticClass: "col-lg-8 campaign-details"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Campaign Details")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('router-link', {
    staticClass: "close-link",
    attrs: {
      "to": {
        name: 'Campaign'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row campaign-details"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('h5', {
    staticClass: "campaign-title"
  }, [_vm._v(_vm._s(_vm.campaign.title))]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Created on:")]), _vm._v(_vm._s(_vm._f("moment")(_vm.campaign.date_created, 'YYYY-MM-DD')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Campaign Type:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaign.campaign_type_display))])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Created By:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaign.created_by))])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Winning Disqualification Duration:")]), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(_vm.convertMillisecondsToMomentDuration(
    _vm.campaign.winning_disqualification_duration
  ).duration_days) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.campaignDetails(_vm.campaign.channel_data.links)), function(channelLink) {
    return _c('div', {
      key: channelLink.id,
      staticClass: "campaign-channels"
    }, [_c('div', {
      staticClass: "campaign-channel"
    }, [_c('label', [_c('social-icon', {
      staticClass: "fa fa-fw",
      attrs: {
        "type": _vm.handleChannelType(channelLink.channel_type_title)
      }
    })], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(channelLink.handle) + ":")]), _vm._v(" "), _c('span', [_vm._v("Keyword: \"" + _vm._s(channelLink.keyword) + "\"")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "campaign-reply-message"
  }, [_c('strong', [_vm._v("Reply Message:")]), _vm._v(" "), _c('span', [_vm._v("\"" + _vm._s(_vm.replyMessage) + "\"")])]), _vm._v(" "), (_vm.campaign.top_engagers.length) ? _c('strong', [_vm._v("Top Engagers:")]) : _vm._e(), _vm._v(" "), _c('dd', {
    staticClass: "project-people"
  }, _vm._l((_vm.campaign.top_engagers), function(profile, index) {
    return _c('engager', {
      key: index,
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelectProfile(profile)
        }
      }
    })
  }), 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('strong', [_vm._v("Start")]), _vm._v("\n                  " + _vm._s(_vm._f("moment")(_vm.campaign.start_date, 'YYYY-MM-DD HH:mm')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('strong', [_vm._v("End")]), _vm._v(" "), (_vm.campaign.perpetual) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Perpetual Campaign")]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.campaign.end_date, 'YYYY-MM-DD HH:mm')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row campaign-breakdown-stats"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('analytics-chart', {
    attrs: {
      "type": "bar",
      "chartStyle": "max-height: 60px",
      "scalesEnabled": false,
      "barPercentage": 0.9,
      "categoryPercentage": 1,
      "show-tooltips": false,
      "data": [
        ['total', _vm.campaignReportData.totals.total_lifetime],
        ['unique', _vm.campaignReportData.totals.unique_lifetime] ]
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 60px",
      "show-tooltips": false,
      "data": _vm.channelTypeChartData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "campaign-totals pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                      " + _vm._s(_vm.campaignReportData.totals.total_lifetime.toLocaleString()) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Total Interactions")])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-totals pull-right"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                      " + _vm._s(_vm.campaignReportData.totals.unique_lifetime.toLocaleString()) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Total Uniques")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "campaign-channel-stats"
  }, _vm._l((_vm.campaignReportData.totals
    .total_vs_unique_channel_type), function(item, key) {
    return (item.total > 0 && item.unique > 0) ? _c('div', {
      key: key,
      staticClass: "row campaign-channel-stat border-top"
    }, [_c('div', {
      staticClass: "col-lg-4 channel-total"
    }, [_vm._v(_vm._s(item.total.toLocaleString()))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 channel-title"
    }, [_vm._v(_vm._s(_vm.formatChannelName(key)))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 channel-unique"
    }, [_vm._v("\n                        " + _vm._s(item.unique.toLocaleString()) + "\n                      ")])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row border-top campaign-periodic-stats"
  }, [(
    _vm.campaignReportData.totals.growth_day ||
    _vm.campaignReportData.totals.growth_week ||
    _vm.campaignReportData.totals.growth_month
  ) ? _c('div', {
    staticClass: "campaign-periodic-stats"
  }, [_c('div', {
    staticClass: "col-lg-4 campaign-periodic-stat"
  }, [_c('div', {
    staticClass: "periodic-total-block pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.total_today.toLocaleString()) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Received")])]), _vm._v(" "), _c('div', {
    staticClass: "periodic-unit-block pull-right"
  }, [_c('div', {
    staticClass: "growth"
  }, [_c('growth', {
    attrs: {
      "value": _vm.campaignReportData.totals.growth_day
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label label-success"
  }, [_vm._v("Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processSparklineData(_vm.campaignReportData.charts.today),
      "gradient": ['#683090', '#c97eff'],
      "height": 40,
      "auto-draw": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "periodic-unique-block"
  }, [_c('div', {
    staticClass: "unique"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.unique_today.toLocaleString()) + "\n                    "), _c('sup', [_vm._v("Unique")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 campaign-periodic-stat"
  }, [_c('div', {
    staticClass: "periodic-total-block pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.total_this_week.toLocaleString()) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Received")])]), _vm._v(" "), _c('div', {
    staticClass: "periodic-unit-block pull-right"
  }, [_c('div', {
    staticClass: "growth"
  }, [_c('growth', {
    attrs: {
      "value": _vm.campaignReportData.totals.growth_week
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label label-info"
  }, [_vm._v("This Week")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processSparklineData(_vm.campaignReportData.charts.this_week),
      "gradient": ['#683090', '#c97eff'],
      "height": 40,
      "auto-draw": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "periodic-unique-block"
  }, [_c('div', {
    staticClass: "unique"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.unique_this_week.toLocaleString()) + "\n                    "), _c('sup', [_vm._v("Unique")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 campaign-periodic-stat"
  }, [_c('div', {
    staticClass: "periodic-total-block pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.total_this_month.toLocaleString()) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Received")])]), _vm._v(" "), _c('div', {
    staticClass: "periodic-unit-block pull-right"
  }, [_c('div', {
    staticClass: "growth"
  }, [_c('growth', {
    attrs: {
      "value": _vm.campaignReportData.totals.growth_month
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label label-primary"
  }, [_vm._v("This Month")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processSparklineData(_vm.campaignReportData.charts.this_month),
      "gradient": ['#683090', '#c97eff'],
      "height": 40,
      "auto-draw": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "periodic-unique-block"
  }, [_c('div', {
    staticClass: "unique"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.unique_this_month.toLocaleString()) + "\n                    "), _c('sup', [_vm._v("Unique")])])])])]) : _c('div', {
    staticClass: "campaign-periodic-stats no-data"
  }, [_c('no-data', {
    staticClass: "label"
  }, [_vm._v("Not enough data to display analytics")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 campaign-main-chart"
  }, [_c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.campaignReportData.charts.channels.constructor === Array ?
        _vm.campaignReportData.charts.channels :
        [],
      "unit": 'month',
      "showLegend": false
    }
  })], 1)])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.profileDialogVisible && _vm.selectedProfile) ? _c('profile-detail-dialog', {
    attrs: {
      "profile": _vm.selectedProfile,
      "profileDialogVisible": _vm.profileDialogVisible,
      "campaignId": _vm.id
    },
    on: {
      "onDialogVisibilityChange": _vm.handleProfileVisibilityChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7684444e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/CampaignDetail.vue
// module id = 3344
// module chunks = 3